// // src/components/StockManagement/StockManagementOutModal.jsx
// import React, { useState, useEffect } from 'react';
// import stockManagementService from '../../services/stockManagementService';
// import SearchableDropdown from './SearchableDropdown';
// import './StockManagement.css';
// import { showNotification } from '../../utils/notification';

// const StockManagementOutModal = ({
//   isOpen, onClose, onSave, isSaving, inventories
// }) => {
//   const [allStocks, setAllStocks] = useState([]);
//   const [availableCategories, setAvailableCategories] = useState([]);
//   const [availableProducts, setAvailableProducts] = useState([]);
//   const [stockOutStaging, setStockOutStaging] = useState([]);
//   const [loadingStocks, setLoadingStocks] = useState(false);
//   const [loadingCategories, setLoadingCategories] = useState(false);
//   const [loadingProducts, setLoadingProducts] = useState(false);
  
//   const [formData, setFormData] = useState({
//     productId: '',
//     fromInventoryId: '',
//     toInventoryId: '',
//     categoryId: '',
//     qty: '1'
//   });

//   // Load stocks when modal opens
//   useEffect(() => {
//     if (isOpen) {
//       console.log('🔵 Modal opened, loading stocks...');
//       resetForm();
//       loadStocksForInventory();
//     }
//   }, [isOpen]);

//   // Monitor allStocks changes
//   useEffect(() => {
//     console.log('📦 Modal allStocks updated:', allStocks.length);
//     if (allStocks.length > 0) {
//       console.log('📦 First stock in modal:', allStocks[0]);
//     }
//   }, [allStocks]);

//   // When fromInventory changes, load categories (only if stocks are loaded)
//   useEffect(() => {
//     if (formData.fromInventoryId && allStocks.length > 0) {
//       console.log('🔄 Inventory selected, loading categories...');
//       loadCategoriesForInventory(formData.fromInventoryId);
//     } else {
//       setAvailableCategories([]);
//       setAvailableProducts([]);
//     }
//   }, [formData.fromInventoryId, allStocks]);

//   // When category changes, load products
//   useEffect(() => {
//     if (formData.categoryId && allStocks.length > 0) {
//       console.log('🔄 Category selected, loading products...');
//       loadProductsForCategory(formData.categoryId);
//     } else {
//       setAvailableProducts([]);
//     }
//   }, [formData.categoryId, allStocks]);

//   const resetForm = () => {
//     setStockOutStaging([]);
//     setFormData({
//       productId: '',
//       fromInventoryId: '',
//       toInventoryId: '',
//       categoryId: '',
//       qty: '1'
//     });
//     setAvailableCategories([]);
//     setAvailableProducts([]);
//     setAllStocks([]);
//   };

//   const loadStocksForInventory = async () => {
//   try {
//     setLoadingStocks(true);
//     console.log('🔍 Loading all stocks from all pages...');
    
//     let allStocksData = [];
//     let currentPage = 1;
//     let hasMorePages = true;
//   const pageSize = 100000;
    
//     // Keep fetching pages until we get all stocks
//     while (hasMorePages) {
//       console.log(`📄 Fetching page ${currentPage}...`);
//       const stocks = await stockManagementService.getAllStocks(currentPage, pageSize);
      
//       if (Array.isArray(stocks) && stocks.length > 0) {
//         allStocksData = [...allStocksData, ...stocks];
//         console.log(`✅ Page ${currentPage}: Got ${stocks.length} stocks. Total so far: ${allStocksData.length}`);
        
//         // If we got fewer items than the page size, we've reached the last page
//         if (stocks.length < pageSize) {
//           hasMorePages = false;
//           console.log('📄 Last page reached');
//         } else {
//           currentPage++;
//         }
//       } else {
//         hasMorePages = false;
//         console.log('📄 No more stocks to fetch');
//       }
//     }
    
//     console.log('✅ Loaded ALL stocks:', allStocksData.length);
//     setAllStocks(allStocksData);
//   } catch (error) {
//     console.error('❌ Error loading stocks:', error);
//     showNotification('Failed to load stocks', 'error');
//     setAllStocks([]);
//   } finally {
//     setLoadingStocks(false);
//   }
// };

//  const loadCategoriesForInventory = async (inventoryId) => {
//   try {
//     setLoadingCategories(true);
//     console.log('========================================');
//     console.log('🔍 LOADING CATEGORIES FOR INVENTORY:', inventoryId);
//     console.log('📦 Total stocks in allStocks:', allStocks.length);
    
//     // Filter stocks for this inventory
//     const inventoryStocks = allStocks.filter(stock => 
//       stock.inventory?.id === parseInt(inventoryId) && stock.qty > 0
//     );
    
//     console.log('📦 Filtered stocks for inventory', inventoryId, ':', inventoryStocks.length);
    
//     // Extract unique categories from products that have stock in this inventory
//     const uniqueCategories = [];
//     const seenCategoryIds = new Set();
    
//     inventoryStocks.forEach((stock, index) => {
//       const category = stock.product?.category;
      
//       if (category && category.id && !seenCategoryIds.has(category.id)) {
//         console.log('✅ ADDING NEW CATEGORY:', category);
//         seenCategoryIds.add(category.id);
//         uniqueCategories.push({
//           id: category.id,
//           name: category.name
//         });
//       }
//     });
    
//     console.log('✅ Final unique categories:', uniqueCategories);
//     console.log('✅ Category IDs seen:', Array.from(seenCategoryIds));
//     console.log('========================================');
    
//     setAvailableCategories(uniqueCategories);
    
//     if (uniqueCategories.length === 0) {
//       showNotification('No categories found in this inventory', 'info');
//     }
//   } catch (error) {
//     console.error('❌ Failed to load categories:', error);
//     showNotification('Failed to load categories', 'error');
//     setAvailableCategories([]);
//   } finally {
//     setLoadingCategories(false);
//   }
// };

// const loadProductsForCategory = async (categoryId) => {
//   try {
//     setLoadingProducts(true);
//     console.log('🔍 Loading products for category:', categoryId);
//     const products = await stockManagementService.getProductsByCategory(categoryId);
//     console.log('✅ Loaded products from API:', products);
    
//     // Show ALL products in this category, regardless of stock
//     // The "Available Qty" field will show 0 if there's no stock in selected inventory
//     const validProducts = (products || []).filter(p => p && p.name && p.id);
    
//     console.log('✅ Valid products to display:', validProducts);
//     setAvailableProducts(validProducts);
//   } catch (error) {
//     console.error('❌ Failed to load products:', error);
//     showNotification('Failed to load products', 'error');
//     setAvailableProducts([]);
//   } finally {
//     setLoadingProducts(false);
//   }
// };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     if (name === 'fromInventoryId') {
//       setFormData(prev => ({
//         ...prev,
//         fromInventoryId: value,
//         categoryId: '',
//         productId: '',
//         qty: '1'
//       }));
//     } else if (name === 'categoryId') {
//       setFormData(prev => ({
//         ...prev,
//         categoryId: value,
//         productId: '',
//         qty: '1'
//       }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }
//   };

//   const getAvailableQty = () => {
//     if (!formData.productId || !formData.fromInventoryId) return 0;
    
//     // Find stock entry for this product in the selected inventory
//     const stockEntry = allStocks.find(s => 
//       s.product?.id === parseInt(formData.productId) && 
//       s.inventory?.id === parseInt(formData.fromInventoryId)
//     );
    
//     return stockEntry?.qty || 0;
//   };

//   const getInventoryName = (inventoryId) => {
//     return inventories.find(inv => inv.id === parseInt(inventoryId))?.name || inventoryId;
//   };

//   const getCategoryName = (categoryId) => {
//     return availableCategories.find(cat => cat.id === parseInt(categoryId))?.name || categoryId;
//   };

//   const getProductName = (productId) => {
//     return availableProducts.find(p => p.id === parseInt(productId))?.name || productId;
//   };

//   const handleAddToDispatch = (e) => {
//     e.preventDefault();
    
//     if (!formData.productId || !formData.fromInventoryId || !formData.toInventoryId || 
//         !formData.categoryId || parseFloat(formData.qty) <= 0) {
//       showNotification('Please fill all required fields', 'error');
//       return;
//     }

//     const availableQty = getAvailableQty();
//     if (parseFloat(formData.qty) > availableQty) {
//       showNotification(`Quantity exceeds available stock (${availableQty})`, 'error');
//       return;
//     }

//     if (formData.fromInventoryId === formData.toInventoryId) {
//       showNotification('Source and destination inventory cannot be the same', 'error');
//       return;
//     }

//     const newItem = {
//       id: Date.now(),
//       productId: parseInt(formData.productId),
//       productName: getProductName(formData.productId),
//       fromInventoryId: parseInt(formData.fromInventoryId),
//       fromInventoryName: getInventoryName(formData.fromInventoryId),
//       toInventoryId: parseInt(formData.toInventoryId),
//       toInventoryName: getInventoryName(formData.toInventoryId),
//       categoryId: parseInt(formData.categoryId),
//       categoryName: getCategoryName(formData.categoryId),
//       qty: parseInt(formData.qty)
//     };

//     setStockOutStaging([...stockOutStaging, newItem]);
    
//     // Reset product selection
//     setFormData(prev => ({
//       ...prev,
//       productId: '',
//       qty: '1'
//     }));
    
//     showNotification('Item added to dispatch log', 'success');
//   };

//   const handleRemoveFromDispatch = (id) => {
//     setStockOutStaging(stockOutStaging.filter(item => item.id !== id));
//   };

//   const handleDispatchBatch = async (e) => {
//     e.preventDefault();
    
//     if (stockOutStaging.length === 0) {
//       showNotification('Add items to the dispatch log before dispatching!', 'error');
//       return;
//     }

//     try {
//       // Format payload according to API spec
//       const payload = {
//         stocks: stockOutStaging.map(item => ({
//           productId: item.productId,
//           fromInventoryId: item.fromInventoryId,
//           toInventoryId: item.toInventoryId,
//           qty: item.qty
//         }))
//       };

//       console.log('📤 Dispatching payload:', payload);
//       await stockManagementService.stockOut(payload);

//       showNotification(`Successfully dispatched ${stockOutStaging.length} items!`, 'success');
      
//       // Call parent to refresh data
//       await onSave();
      
//       // Reset and close
//       resetForm();
//       onClose();
//     } catch (error) {
//       console.error('❌ Error dispatching stock:', error);
//       showNotification('Error dispatching stock: ' + (error.response?.data?.message || error.message), 'error');
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="stock-out-overlay">
//       <div className="stock-out-modal">
//         <header className="stock-out-header">
//           <h3 className="stock-out-title">Stock Out / Dispatch</h3>
//           <button className="stock-out-close-btn" onClick={onClose} disabled={isSaving}>
//             ×
//           </button>
//         </header>

//         <div className="stock-out-body">
//           <div className="stock-out-debug-box">
//             <strong>Debug:</strong> 
//             {loadingStocks ? ' Loading stocks...' : ` Stocks: ${allStocks.length}`} | 
//             Categories: {availableCategories.length} | 
//             Products: {availableProducts.length}
//           </div>

//           <div>
//             <div className="stock-out-form-grid">
//               <label className="stock-out-label">From (Warehouse) *</label>
//               <select
//                 name="fromInventoryId"
//                 className="stock-out-input"
//                 value={formData.fromInventoryId}
//                 onChange={handleChange}
//                 required
//                 disabled={isSaving || loadingStocks || allStocks.length === 0}
//               >
//                 <option value="">
//                   {loadingStocks ? 'Loading stocks...' : allStocks.length === 0 ? 'No stocks available' : 'Select Warehouse'}
//                 </option>
//                 {inventories.map(inv => (
//                   <option key={inv.id} value={inv.id}>
//                     {inv.name}
//                   </option>
//                 ))}
//               </select>

//               <label className="stock-out-label">To (Destination) *</label>
//               <select
//                 name="toInventoryId"
//                 className="stock-out-input"
//                 value={formData.toInventoryId}
//                 onChange={handleChange}
//                 required
//                 disabled={isSaving || loadingStocks}
//               >
//                 <option value="">Select Destination</option>
//                 {inventories.map(inv => (
//                   <option key={inv.id} value={inv.id}>
//                     {inv.name}
//                   </option>
//                 ))}
//               </select>

//               <label className="stock-out-label">Category *</label>
//               <select
//                 name="categoryId"
//                 className="stock-out-input"
//                 value={formData.categoryId}
//                 onChange={handleChange}
//                 required
//                 disabled={isSaving || !formData.fromInventoryId || loadingCategories || allStocks.length === 0}
//               >
//                 <option value="">
//                   {!formData.fromInventoryId 
//                     ? 'Select warehouse first' 
//                     : loadingCategories
//                       ? 'Loading categories...'
//                       : availableCategories.length === 0
//                         ? 'No categories in this inventory'
//                         : 'Select Category'
//                   }
//                 </option>
//                 {availableCategories.map(cat => (
//                   <option key={cat.id} value={cat.id}>
//                     {cat.name}
//                   </option>
//                 ))}
//               </select>

//               <label className="stock-out-label">Product *</label>
//               <SearchableDropdown
//                 products={availableProducts.filter(p => p && p.id && p.name)}
//                 value={formData.productId}
//                 onChange={handleChange}
//                 name="productId"
//                 disabled={isSaving || !formData.categoryId || loadingProducts}
//                 placeholder={
//                   !formData.categoryId 
//                     ? 'Select category first' 
//                     : loadingProducts
//                       ? 'Loading products...'
//                       : availableProducts.length === 0
//                         ? 'No products available'
//                         : 'Select Product'
//                 }
//                 emptyMessage="No products available"
//               />

//               <label className="stock-out-label">Available Qty</label>
//               <input
//                 className="stock-out-input stock-out-read-only"
//                 readOnly
//                 value={getAvailableQty()}
//               />

//               <label className="stock-out-label">Quantity to Dispatch *</label>
//               <input
//                 name="qty"
//                 type="number"
//                 min="1"
//                 max={getAvailableQty()}
//                 className="stock-out-input"
//                 value={formData.qty}
//                 onChange={handleChange}
//                 required
//                 disabled={isSaving || !formData.productId}
//               />
//             </div>

//             <h4 className="stock-out-mini-log-title">Dispatch Log: Items to Ship</h4>
//             <div className="stock-out-mini-log-container">
//               <table className="stock-out-table">
//                 <thead>
//                   <tr className="stock-out-table-row">
//                     <th className="stock-out-table-header">From</th>
//                     <th className="stock-out-table-header">To</th>
//                     <th className="stock-out-table-header">Category</th>
//                     <th className="stock-out-table-header">Product</th>
//                     <th className="stock-out-table-header">Qty</th>
//                     <th className="stock-out-table-header">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {stockOutStaging.length === 0 ? (
//                     <tr>
//                       <td colSpan="6" className="stock-out-no-items-cell">No items added yet.</td>
//                     </tr>
//                   ) : (
//                     stockOutStaging.map(item => (
//                       <tr key={item.id} className="stock-out-table-row">
//                         <td className="stock-out-table-cell">{item.fromInventoryName}</td>
//                         <td className="stock-out-table-cell">{item.toInventoryName}</td>
//                         <td className="stock-out-table-cell">{item.categoryName}</td>
//                         <td className="stock-out-table-cell">{item.productName}</td>
//                         <td className="stock-out-table-cell">{item.qty}</td>
//                         <td className="stock-out-table-cell">
//                           <button
//                             className="stock-out-btn-remove"
//                             onClick={() => handleRemoveFromDispatch(item.id)}
//                             disabled={isSaving}
//                           >
//                             ×
//                           </button>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             Add this temporarily after the debug box
// <button onClick={() => {
//   console.log('=== MANUAL DEBUG ===');
//   console.log('All Stocks:', allStocks);
//   console.log('Selected Inventory ID:', formData.fromInventoryId);
  
//   const filtered = allStocks.filter(s => 
//     s.inventory?.id === parseInt(formData.fromInventoryId)
//   );
//   console.log('Filtered stocks:', filtered);
  
//   const cats = new Set();
//   filtered.forEach(s => {
//     if (s.product?.category?.id) {
//       cats.add(JSON.stringify(s.product.category));
//     }
//   });
//   console.log('Unique categories:', Array.from(cats).map(c => JSON.parse(c)));
// }}>
//   DEBUG: Show Categories
// </button>
//           </div>
//         </div>

//         <footer className="stock-out-footer">
//           <button 
//             className="stock-out-btn stock-out-btn-cancel"
//             onClick={onClose} 
//             disabled={isSaving}
//           >
//             Close
//           </button>
//           <button
//             className="stock-out-btn stock-out-btn-add"
//             onClick={handleAddToDispatch}
//             disabled={isSaving || !formData.productId || loadingStocks}
//           >
//             Add to Dispatch
//           </button>
//           <button
//             className="stock-out-btn stock-out-btn-save"
//             onClick={handleDispatchBatch}
//             disabled={isSaving || stockOutStaging.length === 0}
//           >
//             {isSaving ? 'Processing...' : 'Dispatch Batch'}
//           </button>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default StockManagementOutModal;


// src/components/StockManagement/StockManagementOutModal.jsx
import React, { useState, useEffect } from 'react';
import stockManagementService from '../../services/stockManagementService';
import SearchableDropdown from './SearchableDropdown';
import './StockManagement.css';
import { showNotification } from '../../utils/notification';

const StockManagementOutModal = ({
  isOpen, onClose, onSave, isSaving, inventories
}) => {
  const [allStocks, setAllStocks] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [stockOutStaging, setStockOutStaging] = useState([]);
  const [loadingStocks, setLoadingStocks] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [isDispatching, setIsDispatching] = useState(false);
  const isBusy = isSaving || isDispatching;
  
  const [formData, setFormData] = useState({
    productId: '',
    fromInventoryId: '',
    toInventoryId: '',
    categoryId: '',
    qty: '1'
  });

  // Load stocks when modal opens
  useEffect(() => {
    if (isOpen) {
      console.log('🔵 Modal opened, loading stocks...');
      resetForm();
      loadStocksForInventory();
    }
  }, [isOpen]);

  // Monitor allStocks changes
  useEffect(() => {
    console.log('📦 Modal allStocks updated:', allStocks.length);
    if (allStocks.length > 0) {
      console.log('📦 First stock in modal:', allStocks[0]);
    }
  }, [allStocks]);

  // When fromInventory changes, load categories (only if stocks are loaded)
  useEffect(() => {
    if (formData.fromInventoryId && allStocks.length > 0) {
      console.log('🔄 Inventory selected, loading categories...');
      loadCategoriesForInventory(formData.fromInventoryId);
    } else {
      setAvailableCategories([]);
      setAvailableProducts([]);
    }
  }, [formData.fromInventoryId, allStocks]);

  // When category changes, load products
  useEffect(() => {
    if (formData.categoryId && allStocks.length > 0) {
      console.log('🔄 Category selected, loading products...');
      loadProductsForCategory(formData.categoryId);
    } else {
      setAvailableProducts([]);
    }
  }, [formData.categoryId, allStocks]);

  const resetForm = () => {
    setStockOutStaging([]);
    setFormData({
      productId: '',
      fromInventoryId: '',
      toInventoryId: '',
      categoryId: '',
      qty: '1'
    });
    setAvailableCategories([]);
    setAvailableProducts([]);
    setAllStocks([]);
  };

  const loadStocksForInventory = async () => {
  try {
    setLoadingStocks(true);
    console.log('🔍 Loading all stocks from all pages...');
    
    let allStocksData = [];
    let currentPage = 1;
    let hasMorePages = true;
    const pageSize = 100;
    
    // Keep fetching pages until we get all stocks
    while (hasMorePages) {
      console.log(`📄 Fetching page ${currentPage}...`);
      const stocks = await stockManagementService.getAllStocks(currentPage, pageSize);
      
      if (Array.isArray(stocks) && stocks.length > 0) {
        allStocksData = [...allStocksData, ...stocks];
        console.log(`✅ Page ${currentPage}: Got ${stocks.length} stocks. Total so far: ${allStocksData.length}`);
        
        // If we got fewer items than the page size, we've reached the last page
        if (stocks.length < pageSize) {
          hasMorePages = false;
          console.log('📄 Last page reached');
        } else {
          currentPage++;
        }
      } else {
        hasMorePages = false;
        console.log('📄 No more stocks to fetch');
      }
    }
    
    console.log('✅ Loaded ALL stocks:', allStocksData.length);
    setAllStocks(allStocksData);
  } catch (error) {
    console.error('❌ Error loading stocks:', error);
    showNotification('Failed to load stocks', 'error');
    setAllStocks([]);
  } finally {
    setLoadingStocks(false);
  }
};

 const loadCategoriesForInventory = async (inventoryId) => {
  try {
    setLoadingCategories(true);
    console.log('========================================');
    console.log('🔍 LOADING CATEGORIES FOR INVENTORY:', inventoryId);
    console.log('📦 Total stocks in allStocks:', allStocks.length);
    
    // Filter stocks for this inventory
    const inventoryStocks = allStocks.filter(stock => 
      stock.inventory?.id === parseInt(inventoryId) && stock.qty > 0
    );
    
    console.log('📦 Filtered stocks for inventory', inventoryId, ':', inventoryStocks.length);
    
    // Extract unique categories from products that have stock in this inventory
    const uniqueCategories = [];
    const seenCategoryIds = new Set();
    
    inventoryStocks.forEach((stock, index) => {
      const category = stock.product?.category;
      
      if (category && category.id && !seenCategoryIds.has(category.id)) {
        console.log('✅ ADDING NEW CATEGORY:', category);
        seenCategoryIds.add(category.id);
        uniqueCategories.push({
          id: category.id,
          name: category.name
        });
      }
    });
    
    console.log('✅ Final unique categories:', uniqueCategories);
    console.log('✅ Category IDs seen:', Array.from(seenCategoryIds));
    console.log('========================================');
    
    setAvailableCategories(uniqueCategories);
    
    if (uniqueCategories.length === 0) {
      showNotification('No categories found in this inventory', 'info');
    }
  } catch (error) {
    console.error('❌ Failed to load categories:', error);
    showNotification('Failed to load categories', 'error');
    setAvailableCategories([]);
  } finally {
    setLoadingCategories(false);
  }
};

const loadProductsForCategory = async (categoryId) => {
  try {
    setLoadingProducts(true);
    console.log('🔍 Loading products for category:', categoryId);
    const products = await stockManagementService.getProductsByCategory(categoryId);
    console.log('✅ Loaded products from API:', products);
    
    // Show ALL products in this category, regardless of stock
    // The "Available Qty" field will show 0 if there's no stock in selected inventory
    const validProducts = (products || []).filter(p => p && p.name && p.id);
    
    console.log('✅ Valid products to display:', validProducts);
    setAvailableProducts(validProducts);
  } catch (error) {
    console.error('❌ Failed to load products:', error);
    showNotification('Failed to load products', 'error');
    setAvailableProducts([]);
  } finally {
    setLoadingProducts(false);
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'fromInventoryId') {
      setFormData(prev => ({
        ...prev,
        fromInventoryId: value,
        categoryId: '',
        productId: '',
        qty: '1'
      }));
    } else if (name === 'categoryId') {
      setFormData(prev => ({
        ...prev,
        categoryId: value,
        productId: '',
        qty: '1'
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const getAvailableQty = () => {
    if (!formData.productId || !formData.fromInventoryId) return 0;
    
    // Find stock entry for this product in the selected inventory
    const stockEntry = allStocks.find(s => 
      s.product?.id === parseInt(formData.productId) && 
      s.inventory?.id === parseInt(formData.fromInventoryId)
    );
    
    return stockEntry?.qty || 0;
  };

  const getInventoryName = (inventoryId) => {
    return inventories.find(inv => inv.id === parseInt(inventoryId))?.name || inventoryId;
  };

  const getCategoryName = (categoryId) => {
    return availableCategories.find(cat => cat.id === parseInt(categoryId))?.name || categoryId;
  };

  const getProductName = (productId) => {
    return availableProducts.find(p => p.id === parseInt(productId))?.name || productId;
  };

  const handleAddToDispatch = (e) => {
    e.preventDefault();
    
    if (!formData.productId || !formData.fromInventoryId || !formData.toInventoryId || 
        !formData.categoryId || parseFloat(formData.qty) <= 0) {
      showNotification('Please fill all required fields', 'error');
      return;
    }

    const availableQty = getAvailableQty();
    if (parseFloat(formData.qty) > availableQty) {
      showNotification(`Quantity exceeds available stock (${availableQty})`, 'error');
      return;
    }

    if (formData.fromInventoryId === formData.toInventoryId) {
      showNotification('Source and destination inventory cannot be the same', 'error');
      return;
    }

    const newItem = {
      id: Date.now(),
      productId: parseInt(formData.productId),
      productName: getProductName(formData.productId),
      fromInventoryId: parseInt(formData.fromInventoryId),
      fromInventoryName: getInventoryName(formData.fromInventoryId),
      toInventoryId: parseInt(formData.toInventoryId),
      toInventoryName: getInventoryName(formData.toInventoryId),
      categoryId: parseInt(formData.categoryId),
      categoryName: getCategoryName(formData.categoryId),
      qty: parseInt(formData.qty)
    };

    setStockOutStaging([...stockOutStaging, newItem]);
    
    // Reset product selection
    setFormData(prev => ({
      ...prev,
      productId: '',
      qty: '1'
    }));
    
    showNotification('Item added to dispatch log', 'success');
  };

  const handleRemoveFromDispatch = (id) => {
    setStockOutStaging(stockOutStaging.filter(item => item.id !== id));
  };

  const handleDispatchBatch = async (e) => {
  e.preventDefault();

  // Prevent double click immediately
  if (isBusy) return;

  if (stockOutStaging.length === 0) {
    showNotification('Add items to the dispatch log before dispatching!', 'error');
    return;
  }

  try {
    setIsDispatching(true);

    const payload = {
      stocks: stockOutStaging.map(item => ({
        productId: item.productId,
        fromInventoryId: item.fromInventoryId,
        toInventoryId: item.toInventoryId,
        qty: item.qty
      }))
    };

    console.log('📤 Dispatching payload:', payload);
    await stockManagementService.stockOut(payload);

    showNotification(`Successfully dispatched ${stockOutStaging.length} items!`, 'success');

    await onSave();

    resetForm();
    onClose();
  } catch (error) {
    console.error('❌ Error dispatching stock:', error);
    showNotification(
      'Error dispatching stock: ' + (error.response?.data?.message || error.message),
      'error'
    );
  } finally {
    setIsDispatching(false);
  }
};

  if (!isOpen) return null;

  return (
    <div className="stock-out-overlay">
      <div className="stock-out-modal">
        <header className="stock-out-header">
          <h3 className="stock-out-title">Stock Out / Dispatch</h3>
          <button className="stock-out-close-btn" onClick={onClose} disabled={isBusy}>
            ×
          </button>
        </header>

        <div className="stock-out-body">
          <div className="stock-out-debug-box">
            <strong>Debug:</strong> 
            {loadingStocks ? ' Loading stocks...' : ` Stocks: ${allStocks.length}`} | 
            Categories: {availableCategories.length} | 
            Products: {availableProducts.length}
          </div>

          <div>
            <div className="stock-out-form-grid">
              <label className="stock-out-label">From (Warehouse) *</label>
              <select
                name="fromInventoryId"
                className="stock-out-input"
                value={formData.fromInventoryId}
                onChange={handleChange}
                required
                disabled={isBusy || loadingStocks || allStocks.length === 0}
              >
                <option value="">
                  {loadingStocks ? 'Loading stocks...' : allStocks.length === 0 ? 'No stocks available' : 'Select Warehouse'}
                </option>
                {inventories.map(inv => (
                  <option key={inv.id} value={inv.id}>
                    {inv.name}
                  </option>
                ))}
              </select>

              <label className="stock-out-label">To (Destination) *</label>
              <select
                name="toInventoryId"
                className="stock-out-input"
                value={formData.toInventoryId}
                onChange={handleChange}
                required
                disabled={isBusy || loadingStocks}
              >
                <option value="">Select Destination</option>
                {inventories.map(inv => (
                  <option key={inv.id} value={inv.id}>
                    {inv.name}
                  </option>
                ))}
              </select>

              <label className="stock-out-label">Category *</label>
              <select
                name="categoryId"
                className="stock-out-input"
                value={formData.categoryId}
                onChange={handleChange}
                required
                disabled={isBusy || !formData.fromInventoryId || loadingCategories || allStocks.length === 0}
              >
                <option value="">
                  {!formData.fromInventoryId 
                    ? 'Select warehouse first' 
                    : loadingCategories
                      ? 'Loading categories...'
                      : availableCategories.length === 0
                        ? 'No categories in this inventory'
                        : 'Select Category'
                  }
                </option>
                {availableCategories.map(cat => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>

              <label className="stock-out-label">Product *</label>
              <SearchableDropdown
                products={availableProducts.filter(p => p && p.id && p.name)}
                value={formData.productId}
                onChange={handleChange}
                name="productId"
                disabled={isBusy || !formData.categoryId || loadingProducts}
                placeholder={
                  !formData.categoryId 
                    ? 'Select category first' 
                    : loadingProducts
                      ? 'Loading products...'
                      : availableProducts.length === 0
                        ? 'No products available'
                        : 'Select Product'
                }
                emptyMessage="No products available"
              />

              <label className="stock-out-label">Available Qty</label>
              <input
                className="stock-out-input stock-out-read-only"
                readOnly
                value={getAvailableQty()}
              />

              <label className="stock-out-label">Quantity to Dispatch *</label>
              <input
                name="qty"
                type="number"
                min="1"
                max={getAvailableQty()}
                className="stock-out-input"
                value={formData.qty}
                onChange={handleChange}
                required
                disabled={isBusy || !formData.productId}
              />
            </div>

            <h4 className="stock-out-mini-log-title">Dispatch Log: Items to Ship</h4>
            <div className="stock-out-mini-log-container">
              <table className="stock-out-table">
                <thead>
                  <tr className="stock-out-table-row">
                    <th className="stock-out-table-header">From</th>
                    <th className="stock-out-table-header">To</th>
                    <th className="stock-out-table-header">Category</th>
                    <th className="stock-out-table-header">Product</th>
                    <th className="stock-out-table-header">Qty</th>
                    <th className="stock-out-table-header">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {stockOutStaging.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="stock-out-no-items-cell">No items added yet.</td>
                    </tr>
                  ) : (
                    stockOutStaging.map(item => (
                      <tr key={item.id} className="stock-out-table-row">
                        <td className="stock-out-table-cell">{item.fromInventoryName}</td>
                        <td className="stock-out-table-cell">{item.toInventoryName}</td>
                        <td className="stock-out-table-cell">{item.categoryName}</td>
                        <td className="stock-out-table-cell">{item.productName}</td>
                        <td className="stock-out-table-cell">{item.qty}</td>
                        <td className="stock-out-table-cell">
                          <button
                            className="stock-out-btn-remove"
                            onClick={() => handleRemoveFromDispatch(item.id)}
                            disabled={isBusy}
                          >
                            ×
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            Add this temporarily after the debug box
<button onClick={() => {
  console.log('=== MANUAL DEBUG ===');
  console.log('All Stocks:', allStocks);
  console.log('Selected Inventory ID:', formData.fromInventoryId);
  
  const filtered = allStocks.filter(s => 
    s.inventory?.id === parseInt(formData.fromInventoryId)
  );
  console.log('Filtered stocks:', filtered);
  
  const cats = new Set();
  filtered.forEach(s => {
    if (s.product?.category?.id) {
      cats.add(JSON.stringify(s.product.category));
    }
  });
  console.log('Unique categories:', Array.from(cats).map(c => JSON.parse(c)));
}}>
  DEBUG: Show Categories
</button>
          </div>
        </div>

        <footer className="stock-out-footer">
          <button 
            className="stock-out-btn stock-out-btn-cancel"
            onClick={onClose} 
            disabled={isBusy}
          >
            Close
          </button>
          <button
            className="stock-out-btn stock-out-btn-add"
            onClick={handleAddToDispatch}
            disabled={isBusy || !formData.productId || loadingStocks}
          >
            Add to Dispatch
          </button>
          <button
              className="stock-out-btn stock-out-btn-save"
              onClick={handleDispatchBatch}
              disabled={isBusy || stockOutStaging.length === 0}
            >
              {isBusy ? (
                <>
                  <span className="stock-out-spinner"></span>
                  Processing...
                </>
              ) : (
                'Dispatch Batch'
              )}
            </button>
        </footer>
      </div>
    </div>
  );
};

export default StockManagementOutModal;
